import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { api, eur } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { ProductsPanel } from "../components/admin/ProductsPanel";
import { OrdersPanel } from "../components/admin/OrdersPanel";
import { InstagramPanel } from "../components/admin/InstagramPanel";
import { LaunchPanel } from "../components/admin/LaunchPanel";
import { TwoFactorSetup } from "../components/security/TwoFactor";
import { SecurityPanel } from "../components/security/SecurityPanel";

const Stats = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return null;
  const cards = [["Umsatz", eur(s.revenue)], ["Bestellungen", s.orders], ["Zu versenden", s.to_ship], ["Produkte", s.products], ["Niedriger Bestand", s.low_stock], ["Kunden", s.customers]];
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3" data-testid="admin-stats">
      {cards.map(([l, v]) => (
        <div key={l} className="bg-[#241A3A] rounded-2xl p-4"><p className="text-[10px] uppercase tracking-[0.2em] text-white/50">{l}</p><p className="font-mono text-xl text-[#C9B6F2] mt-2">{v}</p></div>
      ))}
    </div>
  );
};

export default function Admin() {
  const { user, logout, refresh } = useAuth();
  const nav = useNavigate();
  if (user === null) return <div className="min-h-[60vh]" />;
  if (!user || user.role !== "admin") return <Navigate to="/login" />;
  if (!user.twofa_method || !user.mfa) return (
    <div className="bg-[#F7F5FB] min-h-[70vh] py-16 px-4" data-testid="admin-2fa-required">
      <div className="max-w-xl mx-auto bg-white rounded-[28px] border border-[#120E1F]/5 p-8 space-y-5">
        <p className="text-xs uppercase tracking-[0.25em] text-[#F2C230]">Admin</p>
        <h1 className="font-display text-3xl">Zwei-Faktor-Authentifizierung einrichten</h1>
        <p className="text-sm text-[#707783]">Zum Schutz von Shop, Bestellungen und Kundendaten ist 2FA für Admin-Konten Pflicht. Wir empfehlen eine Authenticator-App.</p>
        <TwoFactorSetup onEnabled={refresh} />
      </div>
    </div>
  );
  return (
    <div className="bg-[#F7F5FB] min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
        <div className="flex justify-between items-end">
          <div><p className="text-xs uppercase tracking-[0.25em] text-[#F2C230]">Admin</p><h1 className="font-display text-4xl text-[#120E1F] mt-1" data-testid="admin-title">Shop-Verwaltung</h1></div>
          <button className="btn-outline" data-testid="admin-logout-btn" onClick={async () => { await logout(); nav("/"); }}>Abmelden</button>
        </div>
        <Stats />
        <Tabs defaultValue="products">
          <TabsList className="bg-white border">
            <TabsTrigger value="products" data-testid="admin-tab-products">Produkte</TabsTrigger>
            <TabsTrigger value="orders" data-testid="admin-tab-orders">Bestellungen</TabsTrigger>
            <TabsTrigger value="launch" data-testid="admin-tab-launch">Launch</TabsTrigger>
            <TabsTrigger value="instagram" data-testid="admin-tab-instagram">Instagram</TabsTrigger>
            <TabsTrigger value="security" data-testid="admin-tab-security">Sicherheit</TabsTrigger>
          </TabsList>
          <TabsContent value="products" className="mt-6"><ProductsPanel /></TabsContent>
          <TabsContent value="orders" className="mt-6"><OrdersPanel /></TabsContent>
          <TabsContent value="launch" className="mt-6"><LaunchPanel /></TabsContent>
          <TabsContent value="instagram" className="mt-6"><InstagramPanel /></TabsContent>
          <TabsContent value="security" className="mt-6"><SecurityPanel /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
